<template>
  <div class="position-relative">
    <div class="loader" v-show="loading">
      <img src="/images/loading.svg" rel="preload" alt="Notiek ielāde..">
    </div>
    <table class="table table-responsive-xl table-hover ">
      <thead class="bg-primary text-white">
      <tr>
        <th>Šifrs</th>
        <th>Priekšmeta numurs (min)</th>
        <th>Priekšmeta numurs (max)</th>
        <th>Atskaites izgūšanas diapazons</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="cipher in ciphers">
        <td>{{cipher.title}}</td>
        <td>{{cipher.min_number}}<span v-if="cipher.min_subnumber">-{{cipher.min_subnumber}}</span></td>
        <td>{{cipher.max_number}}<span v-if="cipher.max_subnumber">-{{cipher.max_subnumber}}</span></td>
        <td>
              <form class="form-inline" action="/dashboard/api/numbers/get_unused_numbers" method="POST">
                <input type="hidden" name="_token" :value="csrf">
                <input type="hidden" name="cipher" :value="cipher.title">
                <input class="form-control col-2 mx-sm-3" type="number" name="from" :value="cipher.min_number">
                <input class="form-control col-2 mx-sm-3" type="number" name="to" :value="cipher.max_number">
                <select name="number_type" id="number_type" class="form-control col-2 mx-sm-3">
                  <option value="ir_ievadits">Ir ievadīts</option>
                  <option value="nav_ievadits" selected>Nav ievadīts</option>
                </select>
                <button class="btn btn-primary" formtarget="_blank">Izgūt atskaiti</button>
              </form>
        </td>

      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default
{
  mounted()
  {
    this.getCiphersData()
  },
  data()
  {
    return{
      loading:true,
      ciphers:[],
      number_type:"nav_ievadits",
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    }
  },
  methods:{
    getCiphersData()
    {
      var that = this;
      axios.post('/dashboard/api/numbers/get_min_max_numbers')
      .then(response =>
      {
        that.ciphers = response.data.ciphers;
        that.loading = false;
      });
    }
  }

}
</script>

<style lang="scss">
.loader{
  cursor: progress;
  position:absolute;

  width:100%;
  height:100%;
  display:flex;
  align-items: center;
  justify-content: center;
  background:rgba(255,255,255,0.7);
  img{
    width:100px;
    height:100px;
  }

}
</style>